/* eslint "no-param-reassign": "off" */
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { requestFilterCount } from 'actionCreators';
import { urls } from 'helpers/url';
import cx from 'classnames';
import S from './assignedFilters.scss';

class AssignedFilterItem extends React.Component {
  componentWillMount = () => this.props.requestFilterCount(this.props.item.id);

  componentWillReceiveProps = (nextProps) => {
    const { rerun: newRerun } = nextProps;
    const { rerun, item: { id } } = this.props;
    if (newRerun && newRerun !== rerun) this.props.requestFilterCount(id);
  }

  render = () => {
    const { item, selected, onFilterSelect, filterCounts } = this.props;
    return (<li
      ref={(li) => { this.element = li; }}
      className={cx(S.filter, { [S.selected]: selected, [S.overdue]: filterCounts.overdue })}
    >
      <Link
        to={urls.phases({ query: item.filters })}
        onClick={onFilterSelect}
      >
        <span className={S.name}>{item.name}</span>
        <span className={S.count}>
          {filterCounts.id ? `${filterCounts.overdue_count}/${filterCounts.count}` : 'Loading...'}
        </span>
      </Link>
    </li>);
  }
}

AssignedFilterItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    filters: PropTypes.object,
    id: PropTypes.number.isRequired,
  }).isRequired,
  rerun: PropTypes.bool,
  filterCounts: PropTypes.object,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  onFilterSelect: PropTypes.func.isRequired,
  requestFilterCount: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  rerun: state.assignedFilters.loading,
  filterCounts: state.assignedFilters[`filter${ownProps.item.id}PhaseCounts`] || {
    id: null, count: 0, overdue_count: 0, overdue: false,
  },
});

export default connect(mapStateToProps, { requestFilterCount })(AssignedFilterItem);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/assignedFilterItem.jsx